import filterNodes from 'components/text-editor/hooks/use-custom-editor/actions/filter-nodes';
import { AnyObject } from 'types';
import { Node } from 'slate';

export type GetAnnotations = () => CustomNode[];

type CustomNode = Node & AnyObject;

export default function getAnnotations(editor): GetAnnotations {
  return function (): CustomNode[] {
    return filterNodes(editor)((node) => node.annotationId);
  };
}
